var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("Header", { ref: "header", staticClass: "support-header" }),
        _c("img", {
          staticClass: "loading support-top-bg",
          attrs: { src: _vm.gameData.topBgImage, alt: "" },
        }),
        _c("div", { staticClass: "item_Options" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("UserInfo", {
                ref: "userInfo",
                staticClass: "support-user-info",
              }),
              _c("section", { staticClass: "support-workbench" }, [
                _c("aside", { staticClass: "side-panel" }, [
                  _c("section", { staticClass: "player-card" }, [
                    _c("div", { staticClass: "player-head" }, [
                      _vm._m(0),
                      _c("div", [
                        _c("p", { staticClass: "muted" }, [
                          _vm._v(_vm._s(_vm.$t("game_role_text"))),
                        ]),
                        _c("h2", [
                          _vm._v(_vm._s(_vm.roleInfo.roleName || "-")),
                        ]),
                      ]),
                    ]),
                    _c("dl", { staticClass: "meta-list" }, [
                      _c("div", [
                        _c("dt", [_vm._v(_vm._s(_vm.$t("game_server_text")))]),
                        _c("dd", [
                          _vm._v(
                            _vm._s(
                              _vm.roleInfo.serverName ||
                                _vm.roleInfo.serverCode ||
                                "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v(_vm._s(_vm.$t("support_user_id")))]),
                        _c("dd", [_vm._v(_vm._s(_vm.userId))]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v(_vm._s(_vm.$t("support_game")))]),
                        _c("dd", [
                          _vm._v(_vm._s(_vm.gameData.gameName || "-")),
                        ]),
                      ]),
                      _c("div", [
                        _c("dt", [_vm._v(_vm._s(_vm.$t("support_platform")))]),
                        _c("dd", [_vm._v(_vm._s(_vm.platformName))]),
                      ]),
                    ]),
                  ]),
                  _c("section", { staticClass: "tips-card" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("support_form_type_label"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "quick-list" },
                      _vm._l(_vm.typeOptions, function (opt) {
                        return _c(
                          "button",
                          {
                            key: opt.value,
                            staticClass: "quick-item",
                            class: {
                              active:
                                _vm.showForm &&
                                _vm.defaultTicketType === opt.value,
                            },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.createTicket(opt.value)
                              },
                            },
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.$t(opt.labelKey)))]),
                            _c("small", [_vm._v(_vm._s(_vm.typeCode(opt)))]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _c(
                  "section",
                  {
                    staticClass: "workspace",
                    class: { "chat-workspace": _vm.showChat },
                  },
                  [
                    _c(
                      "nav",
                      {
                        staticClass: "tabs",
                        attrs: { "aria-label": _vm.$t("support_tabs_label") },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "tab",
                            class: { active: _vm.showForm },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.createTicket(
                                  _vm.defaultTicketType ||
                                    _vm.typeOptions[0].value
                                )
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "tab-icon submit-icon" }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("support_submit_issue"))),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "tab",
                            class: { active: !_vm.showForm },
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.showTicketList(false)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "tab-icon list-icon" }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("support_my_questions"))),
                            ]),
                            _vm.ticketCount
                              ? _c("em", [_vm._v(_vm._s(_vm.ticketCount))])
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "section",
                      {
                        ref: "listWrap",
                        staticClass: "view active",
                        class: { "detail-host": _vm.showChat },
                        on: { scroll: _vm.onListScroll },
                      },
                      [
                        _vm.showForm
                          ? _c("SupportForm", {
                              attrs: {
                                "type-options": _vm.typeOptions,
                                "default-type": _vm.defaultTicketType,
                              },
                              on: {
                                submit: _vm.handleSubmit,
                                cancel: _vm.handleCancel,
                              },
                            })
                          : _vm.showChat
                          ? _c("SupportChat", {
                              attrs: {
                                ticket: _vm.activeTicket,
                                "current-ticket": _vm.currentTicket,
                                "support-session": _vm.supportSession,
                                aqId: _vm.aqId,
                                title: _vm.supportTitle,
                              },
                              on: {
                                back: _vm.closeChat,
                                refresh: function ($event) {
                                  return _vm.openChat(_vm.aqId)
                                },
                              },
                            })
                          : _c("div", { staticClass: "tickets-view" }, [
                              _vm.tickets.length
                                ? _c(
                                    "div",
                                    { staticClass: "ticket-list" },
                                    _vm._l(_vm.tickets, function (item, idx) {
                                      return _c("TicketCard", {
                                        key: item.aqId || idx,
                                        attrs: { item: item },
                                        on: {
                                          "click-status": function ($event) {
                                            return _vm.openChat(item.aqId)
                                          },
                                        },
                                      })
                                    }),
                                    1
                                  )
                                : _c("div", { staticClass: "empty-state" }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.$t("support_my_questions"))
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.$t("no_data_text"))),
                                    ]),
                                  ]),
                              _vm.hasMore
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "load-more visible",
                                      attrs: { type: "button" },
                                      on: { click: _vm.loadMore },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.$t("support_load_more")) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isLoading
                                ? _c(
                                    "div",
                                    { staticClass: "support-loading" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-loading",
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("support_submitting"))
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm.closeDialogVisible
                  ? _c(
                      "div",
                      {
                        staticClass: "survey-mask",
                        attrs: {
                          role: "dialog",
                          "aria-modal": "true",
                          "aria-label": _vm.$t("support_survey_title"),
                        },
                        on: {
                          click: function ($event) {
                            if ($event.target !== $event.currentTarget)
                              return null
                            return _vm.dismissCloseDialog.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("section", { staticClass: "survey-dialog" }, [
                          _c(
                            "button",
                            {
                              staticClass: "survey-close",
                              attrs: {
                                type: "button",
                                "aria-label": _vm.$t("support_survey_close"),
                              },
                              on: { click: _vm.dismissCloseDialog },
                            },
                            [_c("i", { staticClass: "el-icon-close" })]
                          ),
                          _c("div", { staticClass: "survey-main" }, [
                            _c(
                              "span",
                              {
                                staticClass: "survey-icon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v("?")]
                            ),
                            _c("div", { staticClass: "survey-copy" }, [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.$t("support_survey_title"))),
                              ]),
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.$t("support_survey_message"))
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "survey-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "survey-button ghost",
                                attrs: { type: "button" },
                                on: { click: _vm.cancelCloseChat },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("support_survey_close")) +
                                    "\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "survey-button primary",
                                attrs: { type: "button" },
                                on: { click: _vm.confirmCloseChat },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("support_mark_solved")) +
                                    "\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]),
        _c("Footer", { staticClass: "support-footer" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "player-avatar", attrs: { "aria-hidden": "true" } },
      [_c("i", { staticClass: "el-icon-user" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }